import React, { useState, createContext, useContext } from 'react';
type StockContextType = {
  outOfStock: string[];
  markOutOfStock: (name: string) => void;
  markInStock: (name: string) => void;
  toggleStock: (name: string) => void;
  isOutOfStock: (name: string) => boolean;
};
const StockContext = createContext<StockContextType | null>(null);
export function StockProvider({
  children
}: {
  children: ReactNode;
}) {
  const [outOfStock, setOutOfStock] = useState<string[]>([]);
  const markOutOfStock = (name: string) => {
    const lower = name.toLowerCase();
    setOutOfStock(prev => prev.includes(lower) ? prev : [...prev, lower]);
  };
  const markInStock = (name: string) => {
    const lower = name.toLowerCase();
    setOutOfStock(prev => prev.filter(n => n !== lower));
  };
  const toggleStock = (name: string) => {
    const lower = name.toLowerCase();
    setOutOfStock(prev => prev.includes(lower) ? prev.filter(n => n !== lower) : [...prev, lower]);
  };
  const isOutOfStock = (name: string) => {
    return outOfStock.includes(name.toLowerCase());
  };
  return <StockContext.Provider value={{
    outOfStock,
    markOutOfStock,
    markInStock,
    toggleStock,
    isOutOfStock
  }} data-id="element-3685">
      {children}
    </StockContext.Provider>;
}
export function useStock() {
  const context = useContext(StockContext);
  if (!context) {
    throw new Error('useStock must be used within a StockProvider');
  }
  return context;
}